import { lazy } from 'react';

export const VangaLandLazy = lazy(() => import('./vanga.land'));
